"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accessControlHOC;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Conditions = _interopRequireDefault(require("../conditions/Conditions"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function accessControlHOC(WrappedComponent, shouldRenderConfig) {
  var AccessControlWrapper =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(AccessControlWrapper, _Component);

    function AccessControlWrapper() {
      (0, _classCallCheck2.default)(this, AccessControlWrapper);
      return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccessControlWrapper).apply(this, arguments));
    }

    (0, _createClass2.default)(AccessControlWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            scopes = _this$props.scopes,
            gates = _this$props.gates,
            rest = (0, _objectWithoutProperties2.default)(_this$props, ["scopes", "gates"]);

        if (_Conditions.default.shouldAccess(shouldRenderConfig)({
          scopes: scopes,
          gates: gates
        })) {
          return _react.default.createElement(WrappedComponent, rest);
        }

        return null;
      }
    }]);
    return AccessControlWrapper;
  }(_react.Component);

  AccessControlWrapper.propTypes = {
    scopes: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]).isRequired,
    gates: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object])
  };
  AccessControlWrapper.displayName = "AccessControl(" + WrappedComponent.name + ")";
  AccessControlWrapper.wrappedComponent = WrappedComponent;
  return AccessControlWrapper;
}

module.exports = exports.default;